import { render, staticRenderFns } from "./OpenCityList.vue?vue&type=template&id=bd8a177e&scoped=true"
import script from "./OpenCityList.vue?vue&type=script&lang=js"
export * from "./OpenCityList.vue?vue&type=script&lang=js"
import style0 from "./OpenCityList.vue?vue&type=style&index=0&id=bd8a177e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8a177e",
  null
  
)

export default component.exports